module.exports = __webpack_public_path__ + "static/media/FillInTheBlank.9b093e91.svg";